import {Component, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {EntityManagementSupportComponent} from "../../../tools/entity-management-support/entity-management-support.component";;
import {TranslateService} from "@ngx-translate/core";
import {OrganizationDepartmentService} from "../../../services/organization/organization-department.service";
import {OrganizationTypeService} from "../../../services/organization/organization-type.service";
import {FormBuilder, Validators} from "@angular/forms";
import * as _ from 'lodash';
import {NzFormatEmitEvent, NzTreeNode} from "ng-zorro-antd/tree";
import {NzIconService} from "ng-zorro-antd/icon";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzContextMenuService, NzDropdownMenuComponent} from "ng-zorro-antd/dropdown";
import {NzModalService} from "ng-zorro-antd/modal";

@Component({
  selector: 'pi-organization-department-management',
  templateUrl: './organization-department-management.component.html',
  styleUrls: ['./organization-department-management.component.css']
})
export class OrganizationDepartmentManagementComponent extends EntityManagementSupportComponent implements OnInit {

  @ViewChild('modalContent') modalContent;
  @Input() iconFontUrl;
  @Input() organizationId;
  @Input() showDepartmentDetail = true;
  searchText;
  dataNameMap = {};
  avaliableParentsSelectList = [];
  unAvaliableParentsSelectList = [];
  nodes = [];
  activatedNode: NzTreeNode;
  currentDepartment;
  inProcess = false;
  operationMode = 'normal';
  organizationTypes: any[];

  constructor(
    private iconService: NzIconService,
    private organizationDepartmentService: OrganizationDepartmentService,
    private organizationTypeService: OrganizationTypeService,
    public notification: NzNotificationService,
    public translateService: TranslateService,
    private nzContextMenuService: NzContextMenuService,
    public modalService: NzModalService,
    private fb: FormBuilder,
    public injector: Injector
  ) {
    // super(translateService, modalService);
    super(injector);
    if (this.iconFontUrl) {
      this.iconService.fetchFromIconfont({
        scriptUrl: this.iconFontUrl
      });
    }

    this.init(this.organizationDepartmentService);
    this.detailForm = this.fb.group({
      code: [null, [Validators.required]],
      name: [null, [Validators.required]],
      departmentType: [null, [Validators.required]],
      description: [null],
      parentId: [-1],
      // pathId: [null, [Validators.required]],
      displayed: [true],
      displayOrder: [1],
    });
  }

  ngOnInit() {
    this.loadData();
    this.loadOrganizationTypes();
  }

  async loadData() {
    this.loading = true;
    this.organizationDepartmentService.searchCurrentOrganizationDepartmentService().subscribe(res => {
      this.dataList = res;
      const nodes = [];
      this.dataList.forEach(d => {
        // this.functionNameMap[d.id] = d.functionName;
        nodes.push({
          title: d.name,
          key: d.id,
          id: d.id,
          metaData: d,
          expanded: true,
          children: []
        });
      });
      this.nodes = this.buildTree(nodes);
      this.loading = false;
    });
  }

  async loadOrganizationTypes() {
    this.organizationTypes = await this.organizationTypeService.getFullData(true).toPromise();
  }


  initDataProcess(dataList) {
    this.getDataNameMap(dataList);
    return dataList;
  }

  buildTree(list) {
    const map = {};
    let node;
    const roots = [];
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.metaData.parentId !== -1) {
        list[map[node.metaData.parentId]].children.push(node);
        list[map[node.metaData.parentId]].children.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
      } else {
        roots.push(node);
        roots.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
      }
    }
    return roots;
  }

  getDataNameMap(dataList) {
    this.dataNameMap = {};
    dataList.forEach(d => {
      this.dataNameMap[d.id] = d.functionName;
    });
  }

  getUnAvaliableParentsSelectList(currentItemId) { // 获取不可成为父功能的id集合
    let arr = [];
    arr = this.dataList.filter(d => d.parentId === currentItemId); // arr = 当前currentItemId子功能的id集合
    arr.forEach(a => { // 如果arr里的子功能还有子功能，则继续循环深入
      if (this.unAvaliableParentsSelectList.indexOf(a.id) === -1) {
        this.unAvaliableParentsSelectList.push(a.id);
      }
      this.getUnAvaliableParentsSelectList(a.id);
    });
  }

  activeNode(data: NzFormatEmitEvent): void {
    this.activatedNode = data.node!;
    this.currentDepartment = data.node.origin.metaData;
    this.detailItem = _.cloneDeep(data.node.origin.metaData);

    this.avaliableParentsSelectList = _.cloneDeep(this.dataList);
    this.unAvaliableParentsSelectList = []; // 每次getUnAvaliableParentsSelectList之前init this.unAvaliableParentsSelectList为空数组
    this.getUnAvaliableParentsSelectList(data.node.origin.id);
    // console.log('this.unAvaliableParentsSelectList', this.unAvaliableParentsSelectList);
    this.avaliableParentsSelectList = this.avaliableParentsSelectList.filter(a => a.id !== data.node.origin.id
      && this.unAvaliableParentsSelectList.indexOf(a.id) === -1);
    // console.log('this.avaliableParentsSelectList', this.avaliableParentsSelectList);
  }

  add() {
    this.detailForm.reset();
    this.operationMode = 'normal';
    this.avaliableParentsSelectList = _.cloneDeep(this.dataList);
    this.unAvaliableParentsSelectList = [];
    this.getUnAvaliableParentsSelectList(undefined);
    this.detailItem = this.detailForm.getRawValue();
    this.currentDepartment = this.detailItem;
  }

  async modify(item) {
    this.operationMode = 'normal';
    this.avaliableParentsSelectList = _.cloneDeep(this.dataList);
    this.unAvaliableParentsSelectList = [];
    this.getUnAvaliableParentsSelectList(item.id);
    this.avaliableParentsSelectList = this.avaliableParentsSelectList.filter(a => a.id !== item.id
      && this.unAvaliableParentsSelectList.indexOf(a.id) === -1);
    this.detailItem = {... item};
  }

  async save() {
    try {
      const saveObj = {... this.detailItem};
      for (const i in this.detailForm.controls) {
        this.detailForm.controls[i].markAsTouched();
        this.detailForm.controls[i].updateValueAndValidity();
      }
      if (this.detailForm.valid) {
        this.inProcess = true;
        const result = await this.entityService.save(this.dataProcessBeforeSave(saveObj)).toPromise();
        this.inProcess = false;
        if (result['code'] === 0) {
          this.notification.success(this.labelSaveSuccess, '');
          this.operationMode = 'normal';
          this.loadData();
          return true;
        } else {
          this.notification.error(result['message'], '');
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      this.inProcess = false;
      return false;
    }
  }

  dataProcessBeforeSave(item) {
    if (!item.parentId) {
      item.parentId = -1
    }
    if (!item.organizationId && this.organizationId != null) {
      item.organizationId = this.organizationId;
    }
    return item;
  }

  copyDepartment(item) {
    this.operationMode = 'copy';
    this.detailItem = {... item};
    delete this.detailItem.id;
  }

  openFolder(data: NzTreeNode | NzFormatEmitEvent): void {
    // do something if u want
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
  }

  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent, metaData): void {
    this.nzContextMenuService.create($event, menu);
    this.detailItem = _.cloneDeep(metaData);
    this.currentDepartment = metaData;
  }

}
